import React, { Fragment } from 'react';
import styled from '@emotion/styled';
import { DOMESTIC_PHONE_NUMBER, INTERNATIONAL_PHONE_NUMBER, LIVE_CHAT_OPERATING_TIMES } from 'config';
import AppLink from 'components/AppLink';

const Unbroken = styled('span')`
  white-space: nowrap;
`;

const linkProps = { to: '/contact-us', underline: true, target: '_blank' };

export const PhoneNumber = () => (
  <Fragment>
    <Unbroken as="strong">{DOMESTIC_PHONE_NUMBER}</Unbroken> (outside Australia : <Unbroken>{INTERNATIONAL_PHONE_NUMBER}</Unbroken>)
  </Fragment>
);

export const ContactLinks = () => (
  <Fragment>
    please contact our customer service team via <AppLink {...linkProps}>email</AppLink> or <AppLink {...linkProps}>live chat</AppLink>
  </Fragment>
);

export const CallCenterHours = () => (
  <Fragment>
    We&apos;re available from <Unbroken as="strong">{LIVE_CHAT_OPERATING_TIMES}</Unbroken> (7 days a week)
  </Fragment>
);
